<script>
export default {
    name: "NoSignatureFileModal",
    data(){
        return{
            visible:false
        }
    },
    methods:{
        handleOk(){
            this.$router.push('/sys/expertInfo')
        }
    }
}
</script>

<template>
    <a-modal v-model:visible="visible" title="提示" @ok="handleOk">
        <template #footer>
            <a-button key="submit" type="primary" @click="handleOk">去上传</a-button>
        </template>
        <p>未上传个人签名，无法审核。</p>
    </a-modal>
</template>

<style scoped lang="less">

</style>
